import { state } from "../state/workspaceStore.js";
import { notFound } from "./NotFoundPage.jsx";
import { clone, id } from "../utils/domain/model.js";
import { head } from "../components/common/PageHeader.jsx";
import {
  btn,
  field,
  check,
  select,
  errorSlot,
} from "../components/forms/FormControls.jsx";
import { applicableProducts } from "../components/coupons/ApplicableProducts.jsx";
import { esc } from "../utils/format.js";
import { applicabilityText } from "../components/coupons/applicability.js";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function couponForm(cid) {
  if (!state.couponDraft) {
    const c = state.db.coupons.find((c) => c.id === cid);
    if (cid && !c) return notFound();
    state.couponDraft = {
      coupon: c
        ? clone(c)
        : {
            id: id("coupon"),
            code: "",
            active: false,
            percent: 15,
            minimum: 1499,
            newOnly: true,
            stacking: false,
            applicability: "all",
            productIds: [],
          },
      welcome: state.db.couponAliases.some(
        (a) => a.code === "WELCOME15" && a.couponId === c?.id && a.active,
      ),
    };
  }
  const c = state.couponDraft.coupon;
  return (
    <>
      {head(
        "COUPONS",
        cid ? "Edit " + c.code : "Add New Coupon",
        "Choose eligible products and coupon rules.",
        btn("Cancel", 'data-nav="coupons"', true),
      )}
      {
        <form id={"coupon-form"} className={"card coupon-form"}>
          <h2>{"Coupon rules"}</h2>
          <div className={"form-grid"}>
            {field(
              "First-order coupon code *",
              "couponCode",
              c.code,
              "text",
              'required maxlength="32"',
            )}
            {field(
              "Discount %",
              "couponPercent",
              c.percent,
              "number",
              'min="0" max="100" step="any" required',
            )}
            {field(
              "Coupon minimum merchandise value ₹",
              "couponMinimum",
              c.minimum,
              "number",
              'min="0" step="0.01" required',
            )}
          </div>
          {check("First-order coupon active", "couponActive", c.active)}
          {check("New customers only", "newOnly", c.newOnly)}
          {check("Allow coupon + offer stacking", "stacking", c.stacking)}
          {check(
            "WELCOME15 active (same eligibility)",
            "welcome15",
            state.couponDraft.welcome,
          )}
          <p className={"hint"}>
            {
              "WELCOME15 is a unique alias with the same product eligibility. Minimum value is evaluated on the entire merchandise subtotal before discounts, as before. Shipping is never eligible."
            }
          </p>
          <div className={"divider"}></div>
          <h2>{"Applicable Products"}</h2>
          {select("Applicable Products", "applicability", c.applicability, [
            ["all", "All products"],
            ["selected", "Select multiple products"],
            ...state.db.products
              .filter((p) => !p.archived)
              .map((p) => [
                "product:" + p.id,
                p.name +
                  " · " +
                  p.skus.map((s) => s.code).join(", ") +
                  (p.status === "Active" ? "" : " · " + p.status),
              ]),
          ])}
          {c.applicability === "selected" ? (
            applicableProducts(c)
          ) : (
            <p className={"hint"}>
              {
                "All available products are eligible. Choose Selected products to restrict this coupon."
              }
            </p>
          )}
          <p className={"hint"}>
            {"Saved applicability: "}
            {esc(applicabilityText(c))}
          </p>
          <div className={"dialog-actions"}>
            {btn("Cancel", 'data-nav="coupons"', true)}
            <button className={"btn"} type={"submit"}>
              {"Save"}
            </button>
          </div>
          {errorSlot()}
        </form>
      }
    </>
  );
}
export default function CouponFormPage({ recordId } = {}) {
  return tableViews(couponForm(recordId));
}
